import { Manager } from './core/Manager';
import { BaseGameScene } from './scene/BaseGameScene';

(async () => {
    await Manager.initialize("#000000");

    console.log("after initialize");

    const game = new BaseGameScene();
    await Manager.changeScene(game, true);

})();